import Vue from 'vue'

import FullPage from './home/fullPage'
import CustomSelectLang from './customSelectLang'
import CustomSelect from './common/customSelect'
import HomeActus from './home/homeActus'
import HomeFocus from './home/homeFocus'
import HomeWorldMap from './home/homeWorldMap'
import HomeWorldMapMobile from './home/homeWorldMapMobile'
import MainMenu from './main-menu'
import AsideSticky from './page-content/asideSticky'
import PageSwiper from './page-content/swiper'
import AudioPlayer from './page-content/audioPlayer'
import VideoPlayer from './page-content/videoPlayer'
import Pagination from './common/paginate'
import ListActus from './actualite/list-actus'
import ListAgenda from './agenda/list-agenda'
import GoogleMap from './common/googleMap'
import ListLibrary from './library/list-library'
import ListRessources from './ressources/list-ressources'
import ListPublications from './publications/list-publications'
import HomeRnnMap from './home/homeRnnMap'
// import ModalJob from './job/modal-job'
import ListStamps from './philatelie/list-stamps'
import RubriqueChild from './page-content/rubrique-child'
import FilterOperation from './operation/filter-operation'
import Newsletter from './common/newsletter'
import AccesPrive from './common/acces-prive'


Vue.component('full-page-menu', FullPage)
Vue.component('custom-select-lang', CustomSelectLang)
Vue.component('home-actus', HomeActus)
Vue.component('home-focus', HomeFocus)
Vue.component('home-world-map', HomeWorldMap)
Vue.component('home-world-map-mobile', HomeWorldMapMobile)
Vue.component('main-menu', MainMenu)
Vue.component('aside-sticky', AsideSticky)
Vue.component('page-swiper', PageSwiper)
Vue.component('audio-player', AudioPlayer)
Vue.component('video-player', VideoPlayer)
Vue.component('pagination', Pagination)
Vue.component('list-actus', ListActus)
Vue.component('list-agenda', ListAgenda)
Vue.component('list-library', ListLibrary)
Vue.component('google-map', GoogleMap)
Vue.component('custom-select', CustomSelect)
Vue.component('list-ressources', ListRessources)
Vue.component('list-publications', ListPublications)
// Vue.component('modal-job', ModalJob)
Vue.component('list-stamps', ListStamps)
Vue.component('rubrique-child', RubriqueChild)
Vue.component('filter-operation', FilterOperation)
Vue.component('newsletter', Newsletter)
Vue.component('acces-prive', AccesPrive)
Vue.component('rnn-map-script', HomeRnnMap)
